import { ReactElement } from 'react';
import { FloatingActionButtonProps, TabStateProps } from '.';
import { useIsImpersonationLoginUser } from '../../../authGuard/hooks/useIsImpersonationLoginUser';

export const TabState = ({
	dataArray,
	activeTab,
	tabClick,
	addNewSite,
	addNewFactoryVisit,
	isGetContractorDetailFetching,
}: TabStateProps): ReactElement => {
	const tabCount = dataArray.length;
	const indicatorWidth = `${100 / tabCount}%`;
	const indicatorLeft = `${(100 / tabCount) * activeTab}%`;
	const isImpersonationLoginUser = useIsImpersonationLoginUser();

	const FloatingActionButton = ({ onClick, ariaLabel, disabled = false }: FloatingActionButtonProps): ReactElement => (
		<div className="container floting-component-wrapper">
			<button type="button" aria-label={ariaLabel} className="floating-btn" onClick={onClick} disabled={disabled}>
				<span className="icon-plus"></span>
			</button>
		</div>
	);

	return (
		<div className="tab-state-wrapper">
			<div className="tab-search-wrapper">
				<div className="tab-wrapper">
					<div className="tab-main">
						<div className="tab-inner">
							<ul className="tab">
								{dataArray.length !== 0 &&
									dataArray?.map((tab, index: number) => {
										return (
											<li
												key={tab.name + `${index + 1}`}
												onClick={() => tabClick(index)}
												className={activeTab === index ? 'active' : ''}
												role="none"
											>
												<div aria-label={tab.name} className="tablinks">
													{tab?.tabIcon && (
														<span className="new-site-icon icon">
															<span className={tab.tabIcon}></span>
														</span>
													)}
													<div className="sites-tab-title">
														<span className={`h3 ${activeTab === index ? 'full' : 'half'}`}>
															{tab.name}
															{tab?.duration && <span className="h5">{tab.duration}</span>}
														</span>
													</div>
												</div>
											</li>
										);
									})}
							</ul>
							<div className="tab-sliding-indicator" style={{ width: indicatorWidth, left: indicatorLeft }}></div>
						</div>
					</div>
				</div>
			</div>

			{(activeTab === 0 || activeTab === 1) && !isImpersonationLoginUser && (
				<FloatingActionButton
					onClick={(e) => addNewSite(e)}
					ariaLabel="add-new-site-button"
					disabled={isGetContractorDetailFetching}
				/>
			)}
			{activeTab === 2 && !isImpersonationLoginUser && (
				<FloatingActionButton
					onClick={addNewFactoryVisit}
					ariaLabel="add-new-factory-visit-button"
					disabled={isGetContractorDetailFetching}
				/>
			)}
		</div>
	);
};
